import { motion } from "framer-motion";
import { fadeUp, stagger, viewportOnce } from "../lib/anim";

export default function BrandPlate() {
  return (
    <motion.section
      variants={stagger}
      initial="hidden"
      whileInView="show"
      viewport={viewportOnce}
      className="relative py-16 sm:py-24 overflow-hidden"
      data-testid="brand-plate"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <motion.p variants={fadeUp} className="font-mono text-xs tracking-[0.22em] uppercase text-neon mb-6 flex items-center gap-3">
          <span className="w-8 h-px bg-gradient-to-r from-neon to-transparent" />
          The signature
        </motion.p>
        <motion.div variants={fadeUp} custom={1} className="frame-spot relative clip-notch p-[2px] bg-gradient-to-r from-neon/40 via-indigo-500/30 to-vio/40" data-testid="brand-plate-frame">
          <div className="clip-notch overflow-hidden bg-black">
            <img src="/images/banner.jpg" alt="Dr. Rahul Kanungo — neon signature" className="w-full h-auto object-cover" />
          </div>
        </motion.div>
      </div>
    </motion.section>
  );
}